import React from "react";
import {AUTH_FLOW_NON_SSO as NON_SSO, AUTH_FLOW_SSO as SSO} from "ubcommunity-shared/src/constants";
import ActivityIndicator from "ubcommunity-shared/src/General/ActivityIndicator/ActivityIndicator";
import LoginForm from "ubcommunity-shared/src/Auth/LoginForm/LoginForm";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import useLoginFlow from "../hooks/useLoginFlow";
import LoginBump from "./LoginBump";
import {View} from "@unibuddy/patron";

export default function LoginFlow() {
    const loginFlow = useLoginFlow();

    const {error} = loginFlow;

    if (error) {
        return <ErrorMessage message={error} />;
    } else {
        const {flow, redirectUrl} = loginFlow;

        switch (flow) {
            case NON_SSO:
                return <LoginForm />;
            case SSO:
                if (redirectUrl) {
                    return <LoginBump redirectUrl={redirectUrl} />;
                }
        }
    }

    return (
        <View padding="large">
            <ActivityIndicator accessibilityLabel="Loading app..." />
        </View>
    );
}
